module.exports = __webpack_public_path__ + "static/img/our-people-overview-quote.7476228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-overview-quote.jpg
// module id = 4Jwu
// module chunks = 0